import { createGlobalStyle } from "styled-components";
import reset from "styled-reset";

const GlobalStyle = createGlobalStyle`
    ${reset};

    $test: 1;

    a{
      text-decoration: none;
      color: inherit;
    }
    *{
      max-width: 100%;
      box-sizing: border-box;
      font-family: "Noto Sans KR", "Noto Sans", -apple-system, BlinkMacSystemFont, "Segoe UI", "Roboto", "Oxygen", "Ubuntu", "Cantarell", "Fira Sans", "Droid Sans", "Helvetica Neue", sans-serif !important;
    }
    html, body{
      margin: 0;
      -webkit-font-smoothing: antialiased;
      -moz-osx-font-smoothing: grayscale;
      font-size: 16px;
      background-color: #fff;
    }
    input, textarea{
      color: #fff;
      font-size: 61px;
    }

    code {
      color: #fff;
      font-family: source-code-pro, Menlo, Monaco, Consolas, 'Courier New', monospace;
    }

    ::selection {
      background-color: #6e1fff;
      color: #fff;
    }
    b{
       font-weight: 700;
    }
`;

export default GlobalStyle;
